export const modules = [
  {
    number: '01',
    name: 'Emprendimiento',
    desc: 'Valida tu idea, construye un modelo de negocio real y escala desde cero sin quemar ahorros.',
    tag: 'Fundamentos',
    icon: (
      <>
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </>
    ),
  },
  {
    number: '02',
    name: 'Marketing Digital',
    desc: 'Estrategia de contenido, branding personal y funnels de venta que funcionan en 2026.',
    tag: 'Estrategia',
    icon: <path d="M22 12h-4l-3 9L9 3l-3 9H2" />,
  },
  {
    number: '03',
    name: 'Wellness & Beauty',
    desc: 'Construye una marca de wellness o beauty que conecta. Rutinas, producto, nutrición y comunidad — sin postureo ni promesas vacías.',
    tag: 'Marca personal',
    icon: (
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    ),
  },
  {
    number: '04',
    name: 'Lifestyle & Eventos',
    desc: 'Diseña experiencias y eventos que la gente recuerda. Hospitalidad, interiorismo, catering y todo lo que convierte un sitio en un destino.',
    tag: 'Experiencias',
    icon: (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <circle cx="12" cy="15" r="2" />
      </>
    ),
  },
  {
    number: '05',
    name: 'Creación de Podcasts',
    desc: 'Lanza tu programa, gana audiencia y monetiza tu voz. Desde el equipo hasta la distribución.',
    tag: 'Contenido',
    icon: (
      <>
        <path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
      </>
    ),
  },
  {
    number: '06',
    name: 'Y mucho más…',
    desc: 'Cada mes sumamos verticales, profesores invitados y workshops nuevos. Síguenos en redes y newsletter para enterarte antes que nadie.',
    tag: 'En expansión',
    icon: <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />,
  },
];
